$(document).ready(function () {


    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * heroSlider
    // *
    // *

    var $heroSlider = $(".js-hero-slider");

    if ($heroSlider.length) {
        $heroSlider.slick({
            fade: true,
            dots: false,
            arrows: true,
            autoplay: true,
            speed: 1000,
            autoplaySpeed: 5000,
            prevArrow: $(".js-hero-slider-nav-prev"),
            nextArrow: $(".js-hero-slider-nav-next"),
            responsive: [
                {
                    breakpoint: 1100,
                    settings: {
                        arrows: false,
                    }
                }
            ]
        });
    }

    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * imageSlider
    // *
    // *

    var $imageSlider = $(".js-image-slider");

    if ($imageSlider.length) {
        $imageSlider.slick({
            fade: true,
            dots: false,
            arrows: true,
            autoplay: true,
            speed: 1000,
            autoplaySpeed: 8000,
            prevArrow: $(".js-image-slider-nav-prev"),
            nextArrow: $(".js-image-slider-nav-next"),
            responsive: []
        });
    }


    // Navbar Trigger
    $('.nav__button').click(function () {
        $('.nav__wrapper').toggleClass('nav__wrapper--open');
    });
    $('.nav__close').click(function () {
        $('.nav__wrapper').toggleClass('nav__wrapper--open');
    });

    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * Scroll to top
    // *
    // *

    $(window).scroll(function () {
        if ($(this).scrollTop() > 300) {
            $('.js-scrolltop').fadeIn();
        } else {
            $('.js-scrolltop').fadeOut();
        }
    });

    $('.js-scrolltop').click(function () {
        $("html, body").animate({
            scrollTop: 0
        }, 600);
        return false;
    });



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * Scroll-To
    // *
    // * Smooth-Scroll to targets on page

    $(".js-hero-scrolldown").click(function () {
        $('html, body').animate({
            scrollTop: $(this).offset().top
        }, 1000);
        return false;
    });



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * Link in a new window
    // *
    // *

    $('a[rel*="external"]').click(function () {
        $(this).attr('target', '_blank');
    });
    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * invert signet
    // *
    // *

    $(window).on("load scroll resize", function () {
        //invert signet on black area
        var isOnBlackElement = false;
        $(".dark").each(function () {
            var logoPos = 100;
            var darkStart = $(this).offset().top - $(window).scrollTop();
            var darkEnd = $(this).offset().top + $(this).outerHeight() - $(window).scrollTop();

            if (logoPos > darkStart && logoPos < darkEnd) {
                $(".nav__button").addClass("invert");
                $(".header").addClass("invert");
                $(".header__logo--light").show();
                $(".header__logo--dark").hide();
                isOnBlackElement = true;
            }
            else if (!isOnBlackElement) {
                $(".nav__button").removeClass("invert");
                $(".header").removeClass("invert");
                $(".header__logo--dark").show();
                $(".header__logo--light").hide();

            }
        });

        var footerpos = $('.footer').offset().top;
        var h = $(window).height();
        var footertop = footerpos - h;
        if (footertop < $(window).scrollTop()) {
            $(".header").hide();
        }  else {
            $(".header").show();
        }
    });

    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * Change navigation by first scroll
    // *
    // *
    $(window).scroll(function () {
        if ($(window).width() > 767) {
            if ($(window).scrollTop() >= 190) {
                $('.header__logo--light').hide();
                $('.header__logo--dark').hide();
                $('.header__logo--mobile').show();
                $('.phone').addClass('scroll');
                $('.appointment').addClass('scroll');
            } else {
                $('.header:not(.invert) .header__logo--dark').show();
                $('.header__logo--mobile').hide();
                $('.phone').removeClass('scroll');
                $('.appointment').removeClass('scroll');
            }
        }

    });
});
